import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-info',
  templateUrl: './show-info.component.html',
  styleUrls: ['./show-info.component.scss'],
})
export class ShowInfoComponent {
  constructor(
    public dialogRef: MatDialogRef<ShowInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
